/* eslint-disable no-throw-literal */
import React, { useState, useEffect } from 'react';
import Container from 'container';
import Headline from 'headline';
import Hero from 'components/templates-default/cohort-hero';
import Breadcrumbs from 'components/templates-default/breadcrumbs';
import { useFormInput, useErrors, useSubmitReady } from 'hooks/useForm';
import useCustomer from 'hooks/useCustomer';
import Input from 'shared/form-input';
import Button from 'button/loading';
import ShopifyErrorBlock from 'shared/shopify-error-block';
import Loading from 'shared/loading';
import { Link, navigate } from 'gatsby';
import ForgotPassword from './forgot-password';
import useGlobal from '@/hooks/useGlobal';

import s from './page-login.module.scss';

export default function PageLogin() {
  const {
    customer,
    customerAccessToken,
    setCustomerAccessToken,
    handleLogin,
    handleLogout,
    loading,
    setLoading
  } = useCustomer();
  const { state, emit } = useGlobal();
  const [showLogin, setShowLogin] = useState(false);
  const [toggleStatus, setToggle] = useState(false); // boolean toggle for showing forgot password or login component
  const [shopifyErrors, setShopifyErrors] = useState('');
  const email = useFormInput('');
  const password = useFormInput('');
  const emailErrors = useErrors({ email: email.state });
  const passwordErrors = useErrors({ password: password.state });
  const submitReady = useSubmitReady({
    email: email.state,
    password: password.state
  });
  const handleSubmit = async e => {
    e.preventDefault();
    setShopifyErrors('');
    setLoading(true);
    const form = {
      email: email.state.value && email.state.value.toLowerCase(),
      password: password.state.value
    };
    try {
      const { data: loginData, shouldChangePassword } = await handleLogin(form);
      if (shouldChangePassword) {
        emit.update({ shouldChangePassword: true, email: email.state.value && email.state.value.toLowerCase() });
        setLoading(false);
        return null;
      }
      if (
        loginData?.customerAccessTokenCreate?.userErrors &&
        loginData.customerAccessTokenCreate.userErrors[0]
      ) {
        throw {
          shopifyError: true,
          error: loginData.customerAccessTokenCreate.userErrors[0]
        };
      }
      const customerAccessToken =
        loginData?.customerAccessTokenCreate?.customerAccessToken?.accessToken;
      await setCustomerAccessToken({
        variables: {
          customerAccessToken
        }
      });
      setLoading(false);
      navigate('/account');
    } catch (e) {
      setLoading(false);
      console.log(e);
      if (e?.error?.message === 'Unidentified customer') {
        setShopifyErrors('Incorrect email or password');
      }
      if (e?.createError) {
        setShopifyErrors(e.createError.replace('GraphQL error:', '').trim());
      }
    }
  };
  useEffect(() => {
    try {
      if (customerAccessToken) {
        if (!state?.shouldChangePassword) {
          navigate('/account');
        }
      } else setShowLogin(true);
    } catch (error) {
      setShowLogin(true);
      console.log(error, 'error');
    }
  }, [customerAccessToken]);


  return (
    <main className={s.root}>
      {showLogin ? (
        <>
          <Hero greywave title="Login" />
          <Breadcrumbs grey pages={[{ name: 'Login', href: '/login' }]} />
          <Container className={s.formContainer}>
            <div className={s.wrapper}>
              {
                !toggleStatus
                  ?
                  (
                    <>
                      <Headline className={s.title} h5 html="Sign Into My Account" />
                      <ShopifyErrorBlock shopifyErrors={shopifyErrors} />
                      {customer ? (
                        <Button
                          type="button"
                          onClick={handleLogout}
                          spin={loading}
                          fallbackText="Logout"
                          disabled={loading}
                        >
                          Logout
                        </Button>
                      ) : (
                        <form onSubmit={handleSubmit} className={s.form}>
                          <Input
                            label="Email"
                            required
                            type="text"
                            name="email"
                            placeholder="Email"
                            {...email.events}
                            error={emailErrors.email}
                            value={email.state.value}
                            className={s.input}
                          />
                          <Input
                            required
                            label="Password"
                            type="password"
                            placeholder="Password"
                            {...password.events}
                            error={passwordErrors.password}
                            value={password.state.value}
                            className={s.input}
                          />
                          <p
                            className={s.customerMessage}
                            onClick={() => { setToggle(true); }}
                          >
                              Forgot Password?
                          </p>
                          <Button
                            type="submit"
                            disabled={!submitReady || loading}
                            className={s.submit}
                            spin={loading}
                            fallbackText="Sign in"
                            small
                            tertiary
                          >
                              Sign in
                          </Button>
                        </form>
                        )}
                      <Headline className={`${s.title} ${s.new}`} h5 html="I'm New Here" />
                      <Button
                        native
                        href="https://cohortcs.com/signup"
                        className={s.submit}
                        small
                        outline
                        tertiary
                      >
                        Create Account
                      </Button>
                    </>
                  )
                  :
                    <ForgotPassword setToggle={setToggle} />
              }
            </div>
          </Container>
        </>
      ) : (
        <Loading />
        )}
    </main>
  );
}
